import React from 'react'
import LoginBusyModal from './login-busy-modal'
import useCurrentUser from '../../hooks/use-current-user'
import { Button, Badge } from 'react-bootstrap'

const ErrorWrapper = ({ children }) => (
    <div
        className='text-center'
        style={{
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'center'
        }}
    >
        {children}
    </div>
)

const NotLoggedIn = ({ onClick = () => {} }) => (
    <ErrorWrapper>
        <div>You must be signed in to use this application.</div>
        <div><Button onClick={() => onClick()}>Click Here To Sign In!</Button></div>
    </ErrorWrapper>
)

const NotVerified = ({ onRefresh = () => {}, onSignOut = () => {}, user = {} }) => (
    <ErrorWrapper>
        <div>Email address verification is required!</div>
        <div>Please verify your email address using the email sent to <Badge variant='secondary' pill>{user.email}</Badge></div>
        <div><Button variant='link' onClick={() => onSignOut()}>-Sign Out-</Button></div>
    </ErrorWrapper>
)

const NotAuthorized = ({ onRefresh = () => {}, onSignOut = () => {}, user = {} }) => (
    <ErrorWrapper>
        <div><Badge variant='secondary' pill>{user.email}</Badge> is not authorized to use this application!</div>
        <div>Please contact an administrator.</div>
        <div><Button variant='link' onClick={() => onSignOut()}>-Sign Out-</Button></div>
    </ErrorWrapper>
)

const AuthorizedUser = ({
    component,
}) => {
    const { isBusy, currentUser, isVerified, isAuthorized, login, logout } = useCurrentUser()
    const reload = () => window.location.reload(false)

    if (isBusy) {
        return (<LoginBusyModal />)
    }

    if (!currentUser) {
        return (<NotLoggedIn onClick={login} />)
    }

    if (!isAuthorized) {
        return (<NotAuthorized onRefresh={reload} user={currentUser} onSignOut={logout} />)
    }

    if (!isVerified) {
        return (<NotVerified onRefresh={reload} user={currentUser} onSignOut={logout}  />)
    }

    const Component = component
    return (<Component />)
}

export default AuthorizedUser